<div class="smooth-scrolling">
    <div class="order-detail">
        <div class="order-title">
            <div class="order-text">
                <h4>your orders</h4>
            </div>
        </div>
        <div *ngIf="this.mOrderDetailListData && this.mOrderDetailListData.length > 0">
            <div class="order-detail-box" *ngFor="let mOrderDetail of  this.mOrderDetailListData">
                <div *ngIf="mOrderDetail && mOrderDetail.product_detail && mOrderDetail.product_detail.length < 2">
                    <div class="order-status-and-number">
                        <div class="order-number-and-placed">
                            <div class="order-number">
                                <label>Order Number</label>
                                <span>{{mOrderDetail.order_number}}</span>
                            </div>
                        </div>
                        <div class="placed-detail">
                            <div class="placed-label">Placed</div>
                            <div class="place-date">{{showDate(mOrderDetail?.order_date)}}</div>
                        </div>
                        <div class="order-status">
                            <label>Order Status</label>
                            <span *ngIf="mOrderDetail?.order_status == 'cancel'" class="c-orange">Cancelled</span>
                            <span *ngIf="mOrderDetail?.order_status != 'cancel'" class="c-orange">{{mOrderDetail?.order_status}}</span>
                        </div>
                    </div>
                    <div class="o-detail">
                        <div class="o-left-detail">
                            <div class="order-content-detail">
                                <label class="product-text">{{mOrderDetail?.product_detail[0]?.brand}}</label>
                                <h4>{{mOrderDetail?.product_detail[0]?.name}}</h4>
                            </div>
                        </div>
                        <div class="qty-detail">
                            <div class="qty-labele">item(S)</div>
                            <div class="qty-item">{{mOrderDetail?.product_detail?.length}}</div>
                        </div>
                    </div>
                    <div class="more-and-btn">
                        <div class="see-more" *ngIf="mOrderDetail?.product_detail?.length > 1">
                            <span>+{{mOrderDetail?.product_detail?.length - 1}}more</span>
                        </div>
                        <div class="o-right-btn">
                            <ul>
                                <li>
                                    <a (click)="itemDeliveredProcess(mOrderDetail)" class="order-bg-black">Order
                                        Detals</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div *ngIf="mOrderDetail && mOrderDetail.product_detail && mOrderDetail.product_detail.length > 1">
                    <div class="order-status-and-number">
                        <div class="order-number-and-placed">
                            <div class="order-number">
                                <label>Order Number</label>
                                <span>{{mOrderDetail.order_number}}</span>
                            </div>
                            <div class="order-place">
                                <label>Placed</label>
                                <span>{{showDate(mOrderDetail?.order_date)}}</span>
                            </div>
                        </div>
                        <div class="order-status">
                            <label>Order Status</label>
                            <span *ngIf="mOrderDetail?.order_status == 'cancel'" class="c-orange">Cancelled</span>
                            <span *ngIf="mOrderDetail?.order_status != 'cancel'" class="c-orange">{{mOrderDetail?.order_status}}</span>
                        </div>
                    </div>
                    <div class="o-detail">
                        <div class="order-left-detail">
                            <div *ngIf="mOrderDetail?.order_status == 'pending'" class="delived-item">
                                {{mOrderDetail?.product_detail?.length}} item(s) in Process</div>
                            <div *ngIf="mOrderDetail?.order_status != 'pending'" class="delived-item">
                                {{mOrderDetail?.product_detail?.length}} item(s) Delivered</div>
                            <ul>
                                <li *ngFor="let productData of mOrderDetail.product_detail, let i = index"
                                    [ngClass]="i >= 3 ? 'd-none' : ''">
                                    <span>
                                        <img src="{{productData?.imageList && productData?.imageList.length > 0 && productData?.imageList[0]?.path ? productData.imageList[0].path : 'assets/images/default-product.png'}}"
                                            alt="image" alt="image" />
                                    </span>
                                </li>
                                <li *ngIf="mOrderDetail && mOrderDetail.product_detail && mOrderDetail.product_detail.length > 3"
                                    (click)="itemDeliveredProcess(mOrderDetail)">
                                    <div class="more">2+ <br /> more</div>
                                </li>
                            </ul>
                        </div>
                        <div class="o-right-btn">
                            <ul>
                                <li>
                                    <a (click)="itemDeliveredProcess(mOrderDetail)" class="order-bg-black">Order
                                        Detals</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Order Empty States start -->
        <div class="order-empty mt-2">
            <div class="empty-text" *ngIf="this.mOrderDetailListData?.length == 0">
                <span>Looks like You haven’t Ordered Anything Yet! </span>
                <small>Discover the Right Products FOR YOU now.</small>
            </div>
            <div class="order-btn-shopping" (click)="startShoping()">
                <a class="start-shopping-btn">Start Shopping</a>
            </div>
        </div>

        <!-- Order Empty States End  -->

    </div>
</div>

<div class="modal fade modal-add-contact" id="confirmation" tabindex="-1" role="dialog">
    <app-confirmation [id]="id" [deleteType]="deleteType"
        (saveClick)="getOrderDetaiList({take: 10,skip: 0,search: 'odr.user_id = ' + id})"></app-confirmation>
</div>